import { HttpClient } from "@angular/common/http";

export abstract class XFoundHttpClient extends HttpClient {
    
}